import Translator from './js/translator';
import translations from './js/languages/languages';

const translator = new Translator();
export default { Translator, translator, translations };
